/**
 * Google Tag Manager — `dataLayer` pushes for conversion events.
 *
 * Configure GTM with **Data Layer variables** for any keys you map into GA4
 * (variable names can match the keys below). Use **Custom Event** triggers on
 * the `event` field.
 *
 * | `event` (trigger name)        | When it fires |
 * | ----------------------------- | ------------- |
 * | `generate_lead`               | HubSpot `bookMeeting` succeeded after “Schedule Demo”. |
 * | `newsletter_subscribe`        | Email newsletter subscription succeeded (not platform sign-up). |
 *
 * Suggested extra keys (same object as the event, for GA4 Event parameters):
 * - `form_id` — identifies the form, e.g. `"book_demo"` or `"newsletter_subscribe"`.
 * - `booking_method` — for demo success: `"scheduler"`.
 *
 * Page/URL/referrer are auto-collected by GA4; do not push them here.
 * For Enhanced Conversions, email may be pushed only inside a nested `user_data`
 * object (never as a top-level event parameter).
 */

export const GTM_EVENT_BOOK_DEMO_SUCCESS = "generate_lead";

export const GTM_EVENT_NEWSLETTER_SUBSCRIBE = "newsletter_subscribe";

export type GtmDataLayerObject = Record<string, unknown>;

export function pushGtmEvent(payload: GtmDataLayerObject): void {
  if (typeof window === "undefined") return;
  const w = window as Window & { dataLayer?: GtmDataLayerObject[] };
  w.dataLayer = w.dataLayer ?? [];
  w.dataLayer.push(payload);
}
